import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchArtworks = () => http.get("/artworks").then((r) => r.data);

export const createCheckoutSession = (payload) =>
  http.post("/checkout/session", payload).then((r) => r.data);

export const getCheckoutStatus = (sessionId) =>
  http.get(`/checkout/status/${sessionId}`).then((r) => r.data);

export const verifyCollector = (password) =>
  http.post("/collector/verify", { password }).then((r) => r.data);

export const submitInquiry = (payload) =>
  http.post("/collector/inquiry", payload).then((r) => r.data);

export const subscribeNewsletter = (email, source = "footer") =>
  http.post("/newsletter/subscribe", { email, source }).then((r) => r.data);

export const followArchive = (firstName, email) =>
  http
    .post("/newsletter/subscribe", { email, source: "the190", first_name: firstName })
    .then((r) => r.data);

export const submitContact = (payload) =>
  http.post("/contact", payload).then((r) => r.data);
